export default __webpack_public_path__ + "static/card-index-middle-3-bf117e3addece7a6cee6f0333b3d0318.jpg";